export class GraphValues {
    label!: string;
    value!: number;

    static fromJson(json: any): GraphValues {
        let result = new GraphValues();
        result.label = json.label;
        result.value = json.value;
        return result;
    }
}
